import { Box, CircularProgress, FormControlLabel, IconButton, Menu, Stack, Switch, TextField, Typography } from '@mui/material';
import OfflinePinIcon from '@mui/icons-material/OfflinePin';
import { FormContainer, SwitchElement, TextFieldElement } from 'react-hook-form-mui';
import SettingsIcon from '@mui/icons-material/Settings';
import { useMemo, useRef, useState } from 'react';
import React from 'react';

import { useSeismicStore } from '../stores/useSeismicStore';
import { SeismicVolumeDefaultsDTO } from '../models/interfaces/DefaultScaleDTO';
import { useSaveDefaultScale } from './attributes/api/useSeismicController';

export const DefaultScaleMenu = () => {
    const surveyMetadata = useSeismicStore(state => state.surveyMetadata);
    const { mutate: saveDefaultScale, isLoading } = useSaveDefaultScale();
    const buttonRef = useRef<HTMLButtonElement|null>(null);
    const [ opened, setOpened ] = useState(false);

    const [setScaleX, setScaleY, scale, absoluteGain, isInverted] = useSeismicStore(state => [state.setScaleX, state.setScaleY, state.scale, state.absoluteGain, state.isInverted]);
    const setIsFlipped = useSeismicStore(state => state.setIsInverted);

    const saveDefaults =  () => {
        saveDefaultScale({
            Flipped: isInverted,
            XScale: scale?.x,
            YScale: scale?.y,
            GainMin: absoluteGain.min,
            GainMax: absoluteGain.max,
            VolumeToken: surveyMetadata?.VolumeToken ?? ''
        });
    };

    return (
        <React.Fragment>
            <IconButton color='primary' ref={buttonRef} onClick={() => setOpened(!opened)}>
                <SettingsIcon />
            </IconButton>
            <Menu
                open={opened}
                anchorEl={buttonRef.current}
                onClose={() => setOpened(false)}
                keepMounted
            >
                <Stack padding='10px' gap={2}>
                    <Typography color='white'>
                        Click on apply button to save the current scale/direction/gain for the current volume.
                    </Typography>

                    <Typography color='white'>
                        These changes will be applied for all users.
                    </Typography>
                    {
                        surveyMetadata
                        &&
                        <IconButton disabled={isLoading} color='primary' onClick={() => saveDefaults()}><OfflinePinIcon/></IconButton>
                    }
                </Stack>
            </Menu>
        </React.Fragment>
    );
};